import { Experiment } from '@ms/yammer-data/dist/state/types';

import { useExperimentTreatmentWithoutReporting } from '../experiments';

type UseIsAskMeAnythingEnabled = () => boolean;
export const useIsAskMeAnythingEnabled: UseIsAskMeAnythingEnabled = () => {
  const isAmaEnabled = useExperimentTreatmentWithoutReporting(Experiment.VivaEngageAma) === true;
  const isVivaEngagePremiumEnabled = useExperimentTreatmentWithoutReporting(Experiment.VivaEngagePremium) === true;

  return isVivaEngagePremiumEnabled && isAmaEnabled;
};
